import {
  useMemo,
  useState,
  useContext,
  createContext,
  useCallback,
} from 'react';

import removeAllNonNumberCharacters from '@/utils/removeAllNonNumberCharacters';

const RastreamentoContext = createContext<any>({});

export const useRastreamento = (): any => useContext(RastreamentoContext);

const RastreamentoProvider: React.FC = ({ children }) => {
  const [documentType, setDocumentType] = useState('cpf');

  const rastreamentoCPForCNPJ = useCallback((data: string) => {
    if (removeAllNonNumberCharacters(data).length > 11)
      return setDocumentType('cnpj');
    return setDocumentType('cpf');
  }, []);

  const value = useMemo(() => {
    return {
      documentType,
      setDocumentType,
      rastreamentoCPForCNPJ,
    };
  }, [documentType, setDocumentType, rastreamentoCPForCNPJ]);

  return (
    <RastreamentoContext.Provider value={value}>
      {children}
    </RastreamentoContext.Provider>
  );
};

export default RastreamentoProvider;
